import type { CarnivalGameState, RevealSinAction } from "../types";
import { resolveSinChoice } from "./resolve-sin";
import { cascadeRoundEnd } from "./round-cascade";

export function applyRevealSin(
  state: CarnivalGameState,
  action: RevealSinAction,
): CarnivalGameState {
  const revealIndex = state.nextToRevealIndex;
  const resolution = resolveSinChoice(
    state.rngState,
    state.dice,
    action.playerId,
    state.seatingOrder,
    action.choice,
  );

  const nextState: CarnivalGameState = {
    ...state,
    rngState: resolution.rngState,
    dice: resolution.dice,
    revealedThisRound: [
      ...state.revealedThisRound,
      { playerId: action.playerId, sin: action.choice.sin, revealIndex },
    ],
    nextToRevealIndex: revealIndex + 1,
  };

  if (nextState.nextToRevealIndex < nextState.revealOrder.length) {
    return nextState;
  }
  return cascadeRoundEnd(nextState);
}
